import React from "react";

const SubtitleComponent = ({ text }) => {
  return <span className="text-xs text-red-600 mb-6">{text}</span>
  ;
};

export default React.memo(SubtitleComponent);
